import Vue from 'vue'
import routerProvider from '@/router/index'
import App from '@/App.vue'
import searcherryConfig from './SearcherryConfig'
import { StatisticService } from '@/services/Statistic/StatisticService'

class Searcherry {
  private app: Vue | null = null
  public statisticService!: StatisticService

  public init () {
    this.statisticService = new StatisticService()
    this.statisticService.createNewSession().finally(() => {
      this.generateEvent('init')

      if (this.app === null) {
        Vue.config.productionTip = false

        let insertToElement = searcherryConfig.getInsertToDomElement()
        if (insertToElement !== null) {
          let wr = document.createElement('div')
          wr.id = 'searcherry'
          insertToElement.appendChild(wr)

          let router = routerProvider.getRouter()

          this.app = new Vue({
            router,
            render: h => h(App)
          })
          this.app.$mount(wr)
        }
      }
    })
  }

  public showSearcherry (randomClass: string) {
    this.init()
    let router = routerProvider.getRouter()

    // Переходим на main
    if (router.currentRoute.name !== 'main') {
      router.push({ name: 'main' }) // it shows view for route /search
    }

    // Если пользователь успел вставить что-то или написать, передаем сразу это в роут
    let target = <HTMLInputElement>document.getElementsByClassName(randomClass)[0]
    setTimeout(function () {
      if (target.value) {
        router.push({ name: 'results', params: { searchPhrase: target.value } })
        target.value = ''
      }
    }, 450)
  }

  public loadStyles () {
    searcherryConfig.cssPaths.forEach(function (cssPath: string) {
      let link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = cssPath
      document.head.appendChild(link)
    })
    if (searcherryConfig.userColor) {
      let userColor = searcherryConfig.userColor
      let style = document.createElement('style')
      let root = ''
      if (userColor.substring(0, 1) === '#') {
        userColor = userColor.replace('#', '')
        let r = parseInt(userColor.substring(0, 2), 16)
        let g = parseInt(userColor.substring(2, 4), 16)
        let b = parseInt(userColor.substring(4, 6), 16)
        root = ':root{--srchrry-user-color: ' + r + ',' + g + ',' + b + ';}'
      } else {
        root = ':root{--srchrry-user-color: ' + userColor + ';}'
      }
      document.head.appendChild(style)
      style.type = 'text/css'
      style.appendChild(document.createTextNode(root))
    }

    this.generateEvent('create')
  }

  public generateEvent (type: string) {
    type = 'searcherry-' + type
    let e = new Event(type)
    document.dispatchEvent(e)
  }

  public saveSearchPhrase (text: string) {
    if (text.length === 0) {
      return
    }
    let searchPhrasesJson = localStorage.getItem('searchPhrasesJson')
    let searchPhrases: Array<string> = []
    if (searchPhrasesJson !== null) {
      searchPhrases = JSON.parse(searchPhrasesJson)
    }

    searchPhrases.unshift(text)
    searchPhrases = searchPhrases.filter((value, index, self) => {
      return self.indexOf(value) === index && value.trim() !== ''
    })

    localStorage.setItem('searchPhrasesJson', JSON.stringify(searchPhrases))
  }
}

declare var searcherry: any
searcherry = new Searcherry()

export default searcherry
